export default __webpack_public_path__ + "static/media/medical3.c8634399.jpg";